"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Facility = void 0;
var Facility;
(function (Facility) {
    function formatForAPI(doc) {
        return {
            id: `${doc.inmateSource}:${doc.facilityId}`,
            inmateSource: doc.inmateSource,
            facilityId: doc.facilityId,
            displayName: doc.displayName,
            importEnabled: doc.importEnabled,
            canvasAccountId: doc.canvasAccountId,
            createdBy: doc.createdBy,
            jpayEnrollment: doc.jpayEnrollment,
            createdOn: doc.createdOn,
            type_facility: 0
        };
    }
    Facility.formatForAPI = formatForAPI;
})(Facility = exports.Facility || (exports.Facility = {}));
//# sourceMappingURL=facility.js.map